/**
 * contains the abi and contract address
*/

class Contract {
    constructor() {
        this.abi = [
	{
		"constant": false,
		"inputs": [
			{
				"name": "country",
				"type": "bytes32"
			}
		],
		"name": "deleteCountry",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "style",
				"type": "bytes32"
			}
		],
		"name": "deleteStyle",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "tag",
				"type": "bytes32"
			}
		],
		"name": "deleteTag",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "country",
				"type": "bytes32"
			}
		],
		"name": "newCountry",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"name": "title",
				"type": "string"
			}
		],
		"name": "newSample",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"name": "tag",
				"type": "bytes32"
			}
		],
		"name": "SampleTagged",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"name": "youtubeVideoId",
				"type": "bytes32"
			}
		],
		"name": "SampledYoutube",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"name": "title",
				"type": "string"
			}
		],
		"name": "SampleCreated",
		"type": "event"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"name": "title",
				"type": "string"
			},
			{
				"name": "youtubeVideoId",
				"type": "bytes32"
			},
			{
				"name": "tagsToAdd",
				"type": "bytes32[4]"
			},
			{
				"name": "stylesToAdd",
				"type": "bytes32[4]"
			},
			{
				"name": "country",
				"type": "bytes32"
			},
			{
				"name": "year",
				"type": "int16"
			}
		],
		"name": "newSampleWithMetadata",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"name": "country",
				"type": "bytes32"
			}
		],
		"name": "SampleCountry",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"name": "year",
				"type": "int16"
			}
		],
		"name": "SampleYear",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"name": "style",
				"type": "bytes32"
			}
		],
		"name": "SampleStyle",
		"type": "event"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "sequenceHash",
				"type": "bytes32"
			},
			{
				"name": "title",
				"type": "string"
			}
		],
		"name": "newSequence",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "style",
				"type": "bytes32"
			}
		],
		"name": "newStyle",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "tag",
				"type": "bytes32"
			}
		],
		"name": "newTag",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "year",
				"type": "int16"
			}
		],
		"name": "newYear",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"name": "sequenceHash",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"name": "title",
				"type": "string"
			}
		],
		"name": "SequenceCreated",
		"type": "event"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"name": "country",
				"type": "bytes32"
			}
		],
		"name": "setSampleCountry",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"name": "stylesToAdd",
				"type": "bytes32[4]"
			},
			{
				"name": "country",
				"type": "bytes32"
			},
			{
				"name": "year",
				"type": "int16"
			}
		],
		"name": "setSampleDiscogsMetadata",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"name": "style",
				"type": "bytes32"
			}
		],
		"name": "setSampleStyle",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"name": "tag",
				"type": "bytes32"
			}
		],
		"name": "setSampleTag",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"name": "tagsToAdd",
				"type": "bytes32[4]"
			}
		],
		"name": "setSampleTags",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"name": "year",
				"type": "int16"
			}
		],
		"name": "setSampleYear",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"name": "youtubeVideoId",
				"type": "bytes32"
			}
		],
		"name": "setSampleYoutubeVideoId",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"constant": true,
		"inputs": [
			{
				"name": "",
				"type": "uint256"
			}
		],
		"name": "allYears",
		"outputs": [
			{
				"name": "",
				"type": "int16"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"name": "",
				"type": "uint256"
			}
		],
		"name": "countries",
		"outputs": [
			{
				"name": "",
				"type": "bytes32"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [],
		"name": "getNumberOfCountries",
		"outputs": [
			{
				"name": "",
				"type": "uint256"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [],
		"name": "getNumberOfStyles",
		"outputs": [
			{
				"name": "",
				"type": "uint256"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [],
		"name": "getNumberOfTags",
		"outputs": [
			{
				"name": "",
				"type": "uint256"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [],
		"name": "getNumberOfYears",
		"outputs": [
			{
				"name": "",
				"type": "uint256"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"name": "",
				"type": "uint256"
			}
		],
		"name": "styles",
		"outputs": [
			{
				"name": "",
				"type": "bytes32"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"name": "",
				"type": "uint256"
			}
		],
		"name": "tags",
		"outputs": [
			{
				"name": "",
				"type": "bytes32"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	}
        ]; 
            
        this.contractAddress = '0x87efb60d3239958f9e6671b45cae668da531a22b';
    }
}

export default Contract;
